import React, { useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  RichTreeView
} from "@dealer-center/core-components";
import styled from "styled-components";
import {
  convertDealerGroupToTreeData,
  convertToCSV,
  getEveryId
} from "./helper";
import { CustomTreeItem as item } from "./customTreeItem";
import type { ReturnInterface } from "@dealer-center/ddc-pages-dashboard-interface";
import { dealerPropertiesToDisplay } from "./treeItemAdditionalInfo";
import { treeItemStyles } from "./treeStyles";

const StyledCard = styled(Card)`
  .panel-body {
    display: block;
  }
`;

interface AccountCardProps {
  data: ReturnInterface[];
  foundAccountIds: string[];
}

export const AccountCardUI = ({ data, foundAccountIds }: AccountCardProps) => {
  const selectedItems: string[] = foundAccountIds
    ? [foundAccountIds[foundAccountIds.length - 1]]
    : [];

  const [expandedItems, setExpandedItems] = React.useState<string[]>(
    foundAccountIds || []
  );
  useEffect(() => {
    if (foundAccountIds) {
      setExpandedItems(foundAccountIds);
    }
  }, [foundAccountIds]);

  const handleExpandedItemsChange = (
    event: React.SyntheticEvent,
    itemIds: string[]
  ) => {
    setExpandedItems(itemIds);
  };
  const dataToUse = convertDealerGroupToTreeData(data);
  const slots = { item };
  return (
    <StyledCard
      content={
        <CardContent>
          <Box
            sx={{
              flexGrow: 1
            }}
          >
            <Box
              sx={{
                display: "flex",
                marginBottom: 2,
                gap: 2
              }}
            >
              <Button
                analyticsConfiguration={{
                  eventName: "Collapse All"
                }}
                onClick={() => {
                  setExpandedItems([]);
                }}
              >
                Collapse All
              </Button>
              <Button
                analyticsConfiguration={{
                  eventName: "Expand All"
                }}
                onClick={() => {
                  setExpandedItems(getEveryId(data));
                }}
              >
                Expand All
              </Button>
              <Button
                analyticsConfiguration={{
                  eventName: "Export"
                }}
                onClick={() => {
                  const csv = convertToCSV(data);
                  const blob = new Blob([csv], { type: "text/csv" });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = "accounts.csv";
                  a.click();
                  URL.revokeObjectURL(url);
                }}
              >
                Export
              </Button>
            </Box>
            <Box sx={{ paddingRight: 1, ...treeItemStyles.itemAreaSX }}>
              <Box sx={treeItemStyles.itemTitleSX} />
              <Box sx={treeItemStyles.itemDetailsSX}>
                {dealerPropertiesToDisplay.map(property => (
                  <Box key={property.key} sx={treeItemStyles.itemDetailsItemSX}>
                    <Box sx={treeItemStyles.itemDetailsLabelSX}>
                      {property.label}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>

            <RichTreeView
              multiSelect
              expandedItems={expandedItems}
              getItemId={item => item.id}
              items={dataToUse}
              selectedItems={selectedItems}
              slots={slots}
              onExpandedItemsChange={handleExpandedItemsChange}
            />
          </Box>
        </CardContent>
      }
      header={<CardHeader title="Accounts" />}
    />
  );
};
